import Vue from "vue";
import VueRouter from "vue-router";

import firebase from "@/firebase";

import Achievements from "@/views/Achievements";
import Admin from "@/views/Admin";
import Documents from "@/views/Documents";
import Login from "@/views/Login";
import Notes from "@/views/Notes";
import PasswordReset from "@/views/PasswordReset";
import Profile from "@/views/Profile";
import Profiles from "@/views/Profiles";
import Questionnaire from "@/views/Questionnaire";
import Register from "@/views/Register";
import Resources from "@/views/Resources";
import Terms from "@/views/Terms";

Vue.use(VueRouter);

const routes = [
  {
    path: "/profiles",
    name: "profiles",
    component: Profiles,
    meta: { requiresAuth: true }
  },
  {
    path: "/achievements",
    name: "achievements",
    component: Achievements,
    meta: { requiresAuth: true }
  },
  {
    path: "/jake-admin",
    name: "admin",
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: "/documents",
    name: "documents",
    component: Documents,
    meta: { requiresAuth: true }
  },
  {
    path: "/embed",
    name: "embed",
    component: Resources
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/notes",
    name: "notes",
    component: Notes,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile/:id",
    name: "profile",
    component: Profile,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/questionnaire/:id",
    name: "questionnaire",
    component: Questionnaire,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/password-reset",
    name: "passwordReset",
    component: PasswordReset
  },
  {
    path: "/resources",
    name: "resources",
    component: Resources,
    meta: { requiresAuth: true }
  },
  {
    path: "/terms",
    name: "terms",
    component: Terms
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0};
  }
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth.currentUser;

  if (requiresAuth && !currentUser) {
    next("/login");
  } else {
    next();
  }

  if (currentUser && to.name === "login") {
    next("/profiles");
  }
});

export default router;
